import { http } from './http.js'


// 语言选项
export async function getLanguage(data) {
  return http('api/Index/language',data,'GET')
}

// 轮播
export async function getBannerList(data) {
  return http('api/banner/index',data,'GET')
}

// 关于我们 文字
export async function getAboutText(data) {
  return http('api/index/about',data,'GET')
}

// 关于我们 列表
export async function getAboutList(data) {
  return http('api/index/news',data,'GET')
}

// 项目实拍 文字
export async function getProjectText(data) {
  return http('api/index/project',data,'GET')
}

// 项目实拍 图片
export async function getProjectImg(data) {
  return http('api/index/project_image',data,'GET')
}

// 联系我们 文字
export async function getContactText(data) {
  return http('api/index/contact',data,'GET')
}

// 联系我们 提交
export async function submitContact(data) {
  return http('api/index/contactus',data,'POST')
}

// 首页置灰
export async function getSetGray(data) {
  return http('api/index/black',data,'GET')
}